var map = {
	"./Avatar-02.svg": "e8ec",
	"./FAVICON-EK-candy.svg": "fea1",
	"./FAVICON-EK-gradient.svg": "2071",
	"./KIDIWI-digital-white.svg": "89d0",
	"./KIDIWI-services-gradient.svg": "2194",
	"./KIDIWI_services-09.png": "34a6",
	"./KIDIWI_services-candy.svg": "d10c",
	"./K_candy.png": "e86f",
	"./background/background000.jpg": "2901",
	"./background/background001.jpg": "549d",
	"./background/background002.jpg": "63ad",
	"./background/background003.jpg": "1cd6",
	"./background/background004.jpg": "a6ed",
	"./background/background005.jpg": "5c8e",
	"./background/background006.jpg": "7cc7",
	"./background/background007.jpg": "ec37",
	"./background/background008.jpg": "761f",
	"./background/background009.jpg": "66d5",
	"./background/background010.jpg": "f2f9",
	"./background/background011.jpg": "3acb",
	"./background/background012.jpg": "2c72",
	"./background/background013.jpg": "6bdf",
	"./background/background014.jpg": "a7ff",
	"./background/background015.jpg": "af28",
	"./background/background016.jpg": "0f2f",
	"./background/background017.jpg": "67ec",
	"./background/background018.jpg": "1bc7",
	"./background/background019.jpg": "6132",
	"./background/background020.jpg": "939d",
	"./background/background021.jpg": "bc23",
	"./background/background022.jpg": "fbd5",
	"./background/background023.jpg": "8903",
	"./background/background024.jpg": "f436",
	"./background/background025.jpg": "f085",
	"./background/background026.jpg": "678a",
	"./background/background027.jpg": "ce2a",
	"./background/background028.jpg": "75ed",
	"./background/background029.jpg": "8bcc",
	"./background/background030.jpg": "441a",
	"./background/background031.jpg": "94de",
	"./background/background032.jpg": "e522",
	"./background/background033.jpg": "d916",
	"./background/background034.jpg": "c887",
	"./background/background035.jpg": "c7e0",
	"./background/background036.jpg": "0a5a",
	"./background/background037.jpg": "11d7",
	"./background/background038.jpg": "7ecc",
	"./background/background039.jpg": "a8da",
	"./background/background040.jpg": "83e3",
	"./background/background041.jpg": "ef70",
	"./background/background042.jpg": "9c11",
	"./background/background043.jpg": "09d9",
	"./background/background044.jpg": "df06",
	"./background/background045.jpg": "7b2c",
	"./background/background046.jpg": "1a96",
	"./background/background047.jpg": "16fd",
	"./background/background048.jpg": "0440",
	"./background/background049.jpg": "5abd",
	"./background/background050.jpg": "3a15",
	"./background/background051.jpg": "02ca",
	"./background/background052.jpg": "3bbc",
	"./background/background053.jpg": "ff8b",
	"./background/background054.jpg": "89a4",
	"./background/background055.jpg": "a26a",
	"./background/background056.jpg": "094c",
	"./background/background057.jpg": "684c",
	"./background/background058.jpg": "def5",
	"./background/background059.jpg": "b1e9",
	"./background/background060.jpg": "8ea9",
	"./background/background061.jpg": "bfcf",
	"./background/background062.jpg": "fc13",
	"./background/background063.jpg": "e048",
	"./background/background064.jpg": "e9d8",
	"./background/background065.jpg": "4016",
	"./background/background066.jpg": "a653",
	"./background/background067.jpg": "e871",
	"./miniweb/basic/MiniwebFrontBasic.png": "4403",
	"./miniweb/elegant/MiniwebFrontElegant.png": "b4f3",
	"./miniweb/wave/miniweb_stylewave_bottom_v01.png": "750a",
	"./miniweb/wave/miniweb_stylewave_experience_v01.png": "cc23",
	"./miniweb/wave/miniweb_stylewave_head_v01.png": "6c88",
	"./team-1.jpg": "296b",
	"./team-2.jpg": "3601",
	"./team-3.jpg": "d981",
	"./team-4.jpg": "353f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";